module.exports = __webpack_public_path__ + "img/四川天府新区合江中学.8903507a.jpg";